import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { selectForumGroupsQueryItems } from '../../../../../../redux/forum-groups/selector';
import { forumGroups } from '../../../../../../redux/forum-groups/action';
import ForumGroupComponent from '../components/forum-group.component';
import { communities } from '../../../../../../redux/community/action';
import { selectCommunitiesListItems } from '../../../../../../redux/community/selector';

const ManagementForumGroup = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const parmas: any = useParams();
  const forumGroupsQuery = useSelector(selectForumGroupsQueryItems);
  const communitiesItems = useSelector(selectCommunitiesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [mediaFiles, setMediaFiles] = useState<any>([])

  const [selectedForumGroups, setSelectedForumGroups] = useState<any>({
    "Name": "",
    "DisplayOrder": 0,
    "CommunityId": 0

  });

  const fetchForumGroupsQueryById = () => {
    dispatch(forumGroups.query({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-groups/query`,
      entity: 'forumGroups',
      jsonData: {
        records: [
          {

            id: parmas?.id
          }
        ]
      }
    })).then(() => {
      setIsQuery(true);
    });
  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedForumGroups({ ...selectedForumGroups, [field]: event });
  }
  const handleFormMediaItemChange: any = ({ value }: any) => {
    setMediaFiles(value);
  }
  useEffect(() => {
    dispatch(communities.list({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/e-appilcations/community/communities/list`,
      entity: 'communities',
      jsonData: {}
    })).then(() => {
      if (parmas?.id > 0) {
        fetchForumGroupsQueryById()
        setIsLoading(false)
      } else {
        setIsLoading(false)
      }
    })
  }, []);

  useEffect(() => {
    if (isQuery) {
      setSelectedForumGroups(forumGroupsQuery?.result?.items);
    }
  }, [isQuery]);

  const handleFormSubmit = async (event: any) => {
    event.preventDefault();
    mediaFiles.splice(
      mediaFiles.length - 1,
      1
    )

    const forumGroupData = {

      "Context": {},
      "Id": selectedForumGroups?.Id || 0,
      "Name": selectedForumGroups?.Name,
      "Description": selectedForumGroups?.Description,
      "DisplayOrder": selectedForumGroups?.DisplayOrder,
      "CommunityId": selectedForumGroups?.CommunityId,
      "MediaMappings": {
        "MediaFiles": mediaFiles,
        "Templates": []

      }
    }
    if (parmas?.id > 0) {
      await dispatch(forumGroups.resetAction({ actionType: 'update' }))
      await dispatch(forumGroups.update({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-groups`,
        entity: 'forumGroups',
        jsonData: {
          records: [
            forumGroupData
          ]
        }
      })).then(() => {
        back();
      });
    } else {
      await dispatch(forumGroups.resetAction({ actionType: 'create' }))
      await dispatch(forumGroups.create({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/one/forum-groups`,
        entity: 'forumGroups',
        jsonData: {
          records: [
            forumGroupData
          ]
        }
      })).then(() => {
        back();
      });
    }
  }

  const back = () => {
    navigate('/management/e-applications/forum/forum-group');
  }

  return (
    <>
      {forumGroupsQuery?.isLoading ? <PageLoader /> :
        <ForumGroupComponent
          handleInnerFormChange={handleInnerFormChange}
          selectedForumGroup={selectedForumGroups}
          back={back}
          handleFormSubmit={handleFormSubmit}
          communities={communitiesItems?.result?.items}
          onFormItemChange={handleFormMediaItemChange}
          id={parmas?.id}
        />
      }
    </>
  );
}

export default ManagementForumGroup;
